import React from "react";
import classes from './PatentRegisterationDocumet.module.scss'
import Document from "../../../../components/Document";
export default function PatentRegisterationDocumet() {
    return(
        <Document/>

    )
    
}